import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Slider from "rc-slider";
import { Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";

const AddBattery = ({ handleAddBattery, userId }) => {
  const [translation] = useTranslation("translations");
  const savedBattery = useSelector((state) => state.batteryLevels.allBatteryLevels);
  const userMemberships = useSelector((state) => state?.userdata?.allUserData?.membership_slugs);
  const [isChange, setIsChange] = useState(false);
  const [batteryLevel, setBatteryLevel] = useState(0);
  const [remarks, setRemarks] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  //const [isRestricted, setIsRestricted] = useState(false);

  useEffect(() => {
    setBatteryLevel(savedBattery?.today_recent_record || 50);    

  }, [savedBattery]);

  let isRestricted = false;

  if ( userMemberships && userMemberships.length === 1 && userMemberships.includes('free') && savedBattery?.total_records >= 5 ) {
    isRestricted = true;
  }

  const handleBatterySubmit = async () => {
    if (remarks?.length === 0) {
      setIsError(true);
      setErrorMsg(translation("remarks_error"));
      setTimeout(() => {
        setIsError(false);
        setErrorMsg("");
      }, 3000);
      return;
    } else {
      if (remarks || batteryLevel) {
        setIsLoading(true);
        await handleAddBattery(0, remarks, batteryLevel);
        resetState();
      }
    }
  };
  const resetState = () => {
    setRemarks("");
    setIsLoading(false);
    setIsChange(false);
  };
  return (
    <Card className={`bg-white ${window.location.pathname === "/" ? 'h-100' : 'mt-3'} border-1 border-light add-battery`}>
      <Card.Body style={{ minHeight: `${window.location.pathname === "/" ? '' : '55vh' }` }}>
        <Card.Title>
            <div className="d-flex">
              <h5 className="mb-3 flex-grow-1">{window.location.pathname === "/" ? 'Hur mår du idag?' : translation("battery_levels")}</h5>
              { window.location.pathname === "/" &&
                <Link to="/my-battery/" className="text-secondary d-inline-block text-decoration-none" style={{ fontSize: "0.9rem" }}>
                  <span className="pe-2">Visa tidigare</span>
                  <i className="fa fa-angle-double-right" aria-hidden="true"></i>
                </Link>
              }
              
            </div>
        </Card.Title>
        <p className="text-mid-grey font-size-medium" >
          {translation("battery-status-description")}
        </p>
        <div className="d-flex justify-content-center align-items-center mt-4 sy-battery">
          <Slider
            className={`${
              batteryLevel >= 0 && batteryLevel <= 20
                ? "battery-red"
                : batteryLevel >= 21 && batteryLevel <= 80
                ? "battery-yellow"
                : batteryLevel >= 81 && batteryLevel <= 100
                ? "battery-green"
                : ""
            }`}
            min={0}
            max={100}
            step={1}
            dotStyle={{
              width: 60,
              height: 12,
              borderRadius: 0,
            }}
            vertical={true}
            handleStyle={{
              width: 60,
              height: 12,
              borderRadius: 0,
              marginLeft: -2,
              transform: "translateY(100%)",
            }}
            value={batteryLevel}
            onChange={(value) => {
              setBatteryLevel(value);
              if (!isChange) {
                setIsChange(true);
              }
            }}
          />

          <div className="mx-3 battery-text-value">
            <b>
              <p
                className={`mb-0`}
                style={{ fontSize: "24px" }}
              >
                {batteryLevel + "%"}
              </p>
            </b>
          </div>
        </div>
        {(isChange || batteryLevel > 0 ) ? (
          <div className="w-100 my-text">

            {isRestricted &&
              <span className="text-secondary font-size-medium mt-3 d-inline-block w-100">Med FREE abonnemanget kan du logga fem gånger. Vill du fortsätta logga ditt mående uppgradera du till ett Sustain You abonnemang genom att maila till <a href="mailto:contact@sustainchange.se" className="text-secondary">contact@sustainchange.se</a></span>
            }

            { ! isRestricted && 
              <form className="mt-5 mt-lg-4" style={{ maxWidth: "800px" }}>
                <h5>{translation("notes")}</h5>
                <div className="row mb-3 px-2 ">
                  <textarea type="textarea"
                    name="first_name"
                    style={{ padding: "0.5rem 0.5rem" }}
                    className="form-control border-1 bg-transparent"
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                  />
                </div>
                <div
                  className={`d-grid gap-2 d-md-flex ${
                    isError ? "justify-content-between" : "justify-content-md-end"
                  }`}
                >
                  {isError && <span className="text-danger">{errorMsg}</span>}
                  <Button
                    className="btn mt-2"
                    size="sm"
                    variant="downriver"
                    onClick={handleBatterySubmit}
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <Spinner
                        animation="border"
                        size="sm"
                        style={{ color: "#fff" }}
                      />
                    ) : (
                      <b>{translation("save")}</b>
                    )}
                  </Button>
                </div>
              </form>
            }
          </div>
        ) : (
          <div></div>
        )}
      </Card.Body>
    </Card>
  );
};
export default AddBattery;
